<div>
    <div class="top-section">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 19 20" fill="none">
            <path
                d="M14.2497 19.1248L18.083 15.2915L16.7413 13.9498L15.208 15.4832V11.4821H13.2913V15.4832L11.758 13.9498L10.4163 15.2915L14.2497 19.1248ZM2.74967 18.1665C2.22259 18.1665 1.77138 17.9788 1.39603 17.6035C1.02068 17.2281 0.833008 16.7769 0.833008 16.2498V2.83317C0.833008 2.30609 1.02068 1.85487 1.39603 1.47952C1.77138 1.10418 2.22259 0.916504 2.74967 0.916504H9.45801L15.208 6.6665V9.56546H13.2913V7.62484H8.49967V2.83317H2.74967V16.2498H8.49967V18.1665H2.74967Z"
                fill="#111111" />
        </svg>

        <!-- <h3 class="m-0"><b>{{'reports.download' | translate }}</b></h3> -->
    </div>
    <div class="center_div">
        <p>{{'download_50000_records' | translate}}</p>
        <p>{{'download_50000_records2' | translate}}</p>
    </div>
</div>